angular.module("admin").factory("AdminUsersService", ["$http", "ENV",function ($http, ENV) {

	/**
	 * API
	 */
	return {
		addUser: addUser,
		deleteUser: deleteUser,
		editUser: editUser,
		getUser: getUser,
		getAllUsers: getAllUsers,
		getUserRoles: getUserRoles,
	};


	function getAllUsers() {
		return $http.get(ENV.API_URL + "/admin/users");
	}

	/**
	 * Mettre à jour un user.
	 * @param user
	 * @returns {*|HttpPromise}
	 */
	function editUser(user) {
		return $http.put(ENV.API_URL + "/admin/users/" + user.id, user);
	}


	/**
	 * Récupérer un user par son ID.
	 *
	 * @param id l'Id du user à récupérer.
	 * @returns {*}
	 */
	function getUser(uuid) {
		return $http.get(ENV.API_URL + "/admin/users/" + uuid);
	}

	/**
	 * Supprimer un user.
	 *
	 * @param user le user à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteUser(user) {
		return $http.delete(ENV.API_URL + "/admin/users/" + user.id);
	}


	/**
	 * POster un user vers le serveur.
	 * @param user
	 * @returns {*|HttpPromise}
	 */
	function addUser(user) {
		user.password = encryptionPassword(user.password);
		return $http.post(ENV.API_URL + "/admin/users", user);
	}

	/**
	 * Renvoie la liste des roles disponibles/affectables à un utilisateur
	 */
	function getUserRoles() {
		return $http.get(ENV.API_URL + "/admin/users/roles");
	}

}]);
